import BugsnagPerformance from '@bugsnag/browser-performance';
import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import React from 'react';

Bugsnag.start({
  apiKey: '6f9784d0ba8bb099149a40ff5f32dc7c',
  plugins: [new BugsnagPluginReact()],
});
BugsnagPerformance.start({ apiKey: '6f9784d0ba8bb099149a40ff5f32dc7c' });

// biome-ignore lint/style/noNonNullAssertion: plugin is always available
export const BugsnagErrorBoundary = Bugsnag.getPlugin('react')!.createErrorBoundary(React);
